import script from "./fw20_prompt_templates.vue?vue&type=script&setup=true&lang=js"
export * from "./fw20_prompt_templates.vue?vue&type=script&setup=true&lang=js"

import "./fw20_prompt_templates.vue?vue&type=style&index=0&id=0d4ed971&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d4ed971"]])

export default __exports__